module.exports = __webpack_public_path__ + "img/13.ca8724e0.png";